import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import type { ListParams } from '@nucleus-commerce/admin-kit/index-table';

import { socialPostsApi } from '../api/social-posts-api';

import { socialKeys } from './social-keys';

/** Shared by the route loader (prefetch) and the page hook (subscribe). */
export function socialPostListQueryOptions(storeId: string, params: ListParams) {
  return queryOptions({
    queryKey: socialKeys.postList(storeId, params),
    queryFn: () => socialPostsApi.list(storeId, params),
    placeholderData: keepPreviousData,
  });
}

export function useSocialPosts(storeId: string, params: ListParams) {
  return useQuery(socialPostListQueryOptions(storeId, params));
}
